module.exports = __webpack_public_path__ + "static/media/pepper-hot.63ea5796.svg";